import { MessageCircle, Phone, Mail } from "lucide-react";
import { EMAIL, LOGO, PHONE_DISPLAY, SECONDARY_PHONE_DISPLAY, telLink, waLink } from "../../lib/constants";

const links = [
  { label: "Home", href: "#home" },
  { label: "Branches", href: "#branches" },
  { label: "Facilities", href: "#facilities" },
  { label: "Fees", href: "#fees" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#1A1A1A] text-white pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2.5 mb-5">
              <div className="w-14 h-14 rounded-md bg-white grid place-items-center overflow-hidden">
                <img src={LOGO} alt="Justudy Library logo" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="font-display font-bold text-white text-lg">
                  Justudy Library
                </div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-[#FACC15]">
                  & Co-working Space
                </div>
              </div>
            </a>
            <p className="text-sm text-white/65 leading-relaxed max-w-md">
              Premium silent study library & co-working space in Noida. Two
              branches — Sector 22 (24/7) and Sector 26 (8 AM – 10 PM).
            </p>
            <div className="mt-5 flex gap-2.5">
              <a
                href={telLink}
                data-testid="footer-call"
                className="inline-flex items-center gap-2 bg-[#FACC15] text-[#1A1A1A] font-semibold px-4 py-2.5 text-sm rounded-sm hover:-translate-y-0.5 transition-transform"
              >
                <Phone className="w-4 h-4" /> Call
              </a>
              <a
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold px-4 py-2.5 text-sm rounded-sm hover:-translate-y-0.5 transition-transform"
              >
                <MessageCircle className="w-4 h-4" /> WhatsApp
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[#FACC15] mb-4 font-semibold">
              Quick Links
            </div>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-sm text-white/70 hover:text-[#FACC15] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-[#FACC15] mb-4 font-semibold">
              Get in Touch
            </div>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-[#FACC15]" /> {PHONE_DISPLAY}
              </li>
              <li className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-[#FACC15]" /> {SECONDARY_PHONE_DISPLAY}
              </li>
              <li className="flex items-center gap-2.5">
                <MessageCircle className="w-4 h-4 text-[#25D366]" />{" "}
                {PHONE_DISPLAY}
              </li>
              <li className="flex items-center gap-2.5 break-all">
                <Mail className="w-4 h-4 text-[#FACC15]" /> {EMAIL}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/45">
          <p>© {new Date().getFullYear()} Justudy Library & Co-working Space. All rights reserved.</p>
          <p className="md:text-right">
            Study Library in Noida · Sector 22 & Sector 26
          </p>
        </div>
      </div>
    </footer>
  );
}
